/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());

    // remove protection or free containers
    if (cartSettings.protection_upsell) {
        // create update payload
        let updatePayload = {};

        // get all protection items
        cart.items.forEach(item => {
            if (item.variant_id === cartSettings.protection_upsell.variants[0].id) {
                updatePayload[item.key] = 0;
            }
        });

        // check if we need to update the cart
        if (Object.keys(updatePayload).length > 0) {
            cart = await updateCart({updates: updatePayload});
            await openCart(true);
            return;
        }
    }

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartHeader").classList.remove("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartUpsell").classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartHeader").classList.add("active");
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartUpsell").classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // append cart
    cart.items.forEach(function (item) {
        // save supplement data
        const supplementData = cartData[item.key];

        // determine if item has properties
        const hasProperties = item.properties && Object.keys(item.properties).length > 0;

        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // property HTML
        function propertiesHTML() {
            // check for any properties
            if (!hasProperties) {
                return "";
            }

            // generate HTML for each item
            let HTML = `<div class="miniCartBodyItemProperties">`;
            for (const key in item.properties) {
                // check for link
                if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                    HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                    continue;
                }

                // catch all
                HTML += `${key}: ${item.properties[key]}<br>`;
            }
            HTML += `</div>`;

            // return string
            return HTML;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // price HTML
        function priceHTML() {
            let HTML = price(item.final_line_price);

            // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
            // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
            const comparePrices = [];

            // check if selling_plan_allocation exists, if so append compare_at_price * quantity
            if (item.selling_plan_allocation) {
                comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
            }

            // check for line item discount
            if (item.original_line_price > item.final_line_price) {
                comparePrices.push(item.original_line_price);
            }

            // check for compare at price
            if (supplementData.compare_at_price) {
                comparePrices.push(supplementData.compare_at_price * item.quantity);
            }

            // if there is at least one compare price
            if (comparePrices.length > 0) {
                // find the greatest compare price
                const greatestComparePrice = Math.max(...comparePrices);

                // check if the greatest compare price is greater than the final line price
                if (greatestComparePrice > item.final_line_price) {
                    HTML += `
                        <s>${price(greatestComparePrice)}</s>
                    `;
                }
            }
            //<span>(Save ${price(greatestComparePrice - item.final_line_price)})</span>

            return HTML;
        }

        // upgrade button HTML
        function upgradeHTML() {

            // check if already a subscription
            if (item.selling_plan_allocation) {
                return "";
            }

            // check if selling plan exists
            if (!supplementData["selling_plan_id"]) {
                return "";
            }

            // return HTML
            return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-plan="${supplementData["selling_plan_id"]}"
                     type="button"
                >
               ${supplementData["selling_plan_name"]}
                </button>
            `;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <img class="miniCartBodyItemImage" src="${item.image}&width=200" alt="${item.product_title}">
                <div>
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <div class="miniCartBodyItemTitle">${item.product_title}</div>
                            
                            ${propertiesHTML()}
                            ${subscriptionHTML()}
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>
                    </div>
                    <div class="miniCartBodyItemFlex">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus" type="button" aria-label="decrement quantity of ${item.product_title}">-</button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus" type="button" aria-label="increment quantity of ${item.product_title}">+</button>
                        </div>
                        <button class="miniCartBodyItemRemove" type="button" aria-label="remove item from cart">
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_352_1246)">
                            <path d="M23.1465 5.925H1.85273C1.33398 5.925 0.912109 5.50312 0.912109 4.98437C0.912109 4.46562 1.33398 4.04375 1.85273 4.04375H23.1465C23.6652 4.04375 24.0871 4.46562 24.0871 4.98437C24.0871 5.50312 23.6652 5.925 23.1465 5.925Z" fill="#474747"/>
                            <path d="M12.9853 24.7125H12.0166C8.55406 24.7125 6.64781 24.7125 5.29156 23.4469C3.93843 22.1813 3.81031 20.2781 3.57906 16.8219L3.00406 8.18125C2.96968 7.6625 3.36031 7.21563 3.87906 7.18125C4.39781 7.14688 4.84468 7.5375 4.87906 8.05625L5.45406 16.6969C5.66031 19.7719 5.76343 21.3156 6.57593 22.075C7.38843 22.8344 8.93531 22.8344 12.0166 22.8344H12.9853C16.0666 22.8344 17.6134 22.8344 18.4259 22.075C19.2384 21.3156 19.3416 19.7719 19.5478 16.6969L20.1228 8.05625C20.1572 7.5375 20.6072 7.14688 21.1228 7.18125C21.6416 7.21563 22.0322 7.6625 21.9978 8.18125L21.4228 16.8219C21.1916 20.2781 21.0666 22.1813 19.7103 23.4469C18.3572 24.7125 16.4478 24.7125 12.9853 24.7125Z" fill="#474747"/>
                            <path d="M9.99404 18.45C9.51592 18.45 9.10967 18.0875 9.05967 17.6031L8.43467 11.3406C8.38154 10.825 8.75967 10.3625 9.27529 10.3125C9.79092 10.2594 10.2534 10.6375 10.3034 11.1531L10.9284 17.4156C10.9815 17.9312 10.6034 18.3937 10.0878 18.4437C10.0565 18.4469 10.0253 18.45 9.99404 18.45Z" fill="#474747"/>
                            <path d="M15.0058 18.45C14.9745 18.45 14.9433 18.45 14.912 18.4437C14.3964 18.3906 14.0183 17.9312 14.0714 17.4156L14.6964 11.1531C14.7495 10.6375 15.2089 10.2594 15.7245 10.3125C16.2401 10.3656 16.6183 10.825 16.5651 11.3406L15.9401 17.6031C15.8901 18.0875 15.4839 18.45 15.0058 18.45Z" fill="#474747"/>
                            <path d="M19.3902 5.925C19.309 5.925 19.2684 5.925 19.2309 5.925C18.534 5.90625 17.8684 5.68438 17.3027 5.275C16.7371 4.86875 16.3152 4.30625 16.0777 3.65313C16.0652 3.61875 16.0527 3.57813 16.0246 3.5L15.9027 3.13438C15.8215 2.89375 15.7715 2.7375 15.7371 2.67188C15.5996 2.40938 15.3434 2.225 15.0527 2.17813C14.9777 2.16563 14.8121 2.16563 14.5621 2.16563H10.4434C10.1902 2.16563 10.0246 2.16563 9.95273 2.17813C9.65898 2.225 9.40586 2.40938 9.26836 2.67188C9.23398 2.7375 9.18086 2.89688 9.10273 3.13438L8.98086 3.5C8.95586 3.57813 8.94023 3.61563 8.92773 3.65313C8.69023 4.30625 8.26836 4.86875 7.70273 5.275C7.13711 5.68125 6.47148 5.90625 5.77461 5.925C5.73711 5.925 5.69648 5.925 5.61523 5.925V4.04688C5.67148 4.04688 5.70273 4.04688 5.72773 4.04688C6.37773 4.03125 6.94023 3.625 7.15898 3.01563C7.16836 2.99063 7.17773 2.9625 7.19648 2.90938L7.31836 2.54375C7.43398 2.19688 7.49648 2.00625 7.59961 1.80625C8.00898 1.01875 8.77773 0.465627 9.65586 0.325002C9.87773 0.290627 10.0777 0.290627 10.4434 0.290627H14.5621C14.9277 0.290627 15.1277 0.290627 15.3496 0.325002C16.2277 0.465627 16.9934 1.01875 17.4059 1.80625C17.509 2.00313 17.5715 2.19375 17.6871 2.54063L17.809 2.90938C17.8277 2.96563 17.8371 2.99063 17.8465 3.01563C18.0684 3.625 18.6309 4.03125 19.2777 4.04688C19.3027 4.04688 19.334 4.04688 19.3902 4.04688V5.925Z" fill="#474747"/>
                            </g><defs><clipPath id="clip0_352_1246"><rect width="25" height="25" fill="white"/></clipPath></defs>
                            </svg>
                        </button>
                    </div>
                </div>
                ${upgradeHTML()}
            </div>
        `);

    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            element.classList.remove("active");
        } else {
            element.classList.add("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsell").classList.remove("active");
    }

    // add protection price to ATC button if checked
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price + cartSettings.protection_upsell.variants[0].price);
    } else {
        document.querySelector("#miniCartFooterCheckoutPrice").textContent = price(cart.items_subtotal_price);
    }
}

// Add Upsell function
document.querySelectorAll('.miniCartUpsellItemWrapATC').forEach(function (element) {
    element.addEventListener("click", async function () {
        // get variant ID from dropdown selector
        const variantID = this.closest('.miniCartUpsellItem').dataset.variant;

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // create form data
        let formData = {
            items: [{
                quantity: 1,
                id: variantID,
            }]
        };

        // check for selling plan
        if (this.closest('.miniCartUpsellItem').dataset.plan) {
            let sellingPlanID = this.closest('.miniCartUpsellItem').dataset.plan;
            formData = {
                items: [{
                    quantity: 1,
                    id: variantID,
                    selling_plan: sellingPlanID
                }]
            };
        }

        // add product upsell
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        await openCart();
    });
});

// event listener for body
document.querySelector('#miniCartBody').addEventListener('click', async (e) => {

    const item = e.target.closest('.miniCartBodyItem');
    // if not an item, return
    if (!item) return;

    // get key
    let key = item.dataset.key;
    // get current quantity
    let quantity = parseInt(item.querySelector(".miniCartBodyItemQuantityCount").textContent);

    // minus button
    const minus = e.target.closest('.miniCartBodyItemQuantityMinus');
    if (minus) {
        if (quantity === 1) {
            quantity = 0;
            await updateCartItem(item, key, quantity);
        } else {
            quantity--;
            await updateCartItem(item, key, quantity);
        }
        return;
    }

    // plus button
    const plus = e.target.closest('.miniCartBodyItemQuantityPlus');
    if (plus) {
        quantity++;
        await updateCartItem(item, key, quantity);
        return;
    }

    // remove button
    const remove = e.target.closest('.miniCartBodyItemRemove');
    if (remove) {
        quantity = 0;
        await updateCartItem(item, key, quantity);
        return;
    }

    // upgrade to subscription button
    const upgrade = e.target.closest('.miniCartBodyItemUpgrade');
    if (upgrade) {
        const sellingPlanID = parseInt(upgrade.dataset.plan);

        // start loading animation
        document.querySelector("#miniCartContent").classList.add("loading");

        // add selling plan
        cart = await changeCart({
            id: key,
            quantity: quantity,
            selling_plan: sellingPlanID
        });

        await openCart(true);
    }
})

// update quantity function
async function updateCartItem(item, key, quantity) {
    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");
    // update quantity input
    item.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

    // update cart in shopify
    cart = await updateCart({
        updates: {
            [key]: quantity
        }
    });

    // update active body
    await openCart(true);
}


// listen for protection plan switch
document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.addEventListener("change", async function () {
    await openCart(true);
});

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close cart function
function closeCart() {
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // check if protection product is checked - if so atc
    if (document.querySelector("#miniCartFooterUpsellTopSwitchInput")?.checked) {
        // add protection product
        formData.items.push({
            quantity: 1,
            id: cartSettings.protection_upsell.variants[0].id,
        });
    }

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
    window.location.href = `${Shopify.routes.root}checkout`;
});

// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}

if (document.querySelector("#miniCartFooterContinue")) {
    document.querySelector("#miniCartFooterContinue").addEventListener("click", function () {
        closeCart();
    });
}